var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerAutomateSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "1~WE0Lz3GgLZUex~1j_nwa",
    x1: 10.281,
    x2: 24.742,
    y1: 1.322,
    y2: 16.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FC0449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC0449"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#1~WE0Lz3GgLZUex~1j_nwa)",
    d: "M4.662,6.941c-0.001,0-0.003,0-0.004,0c-1.42,0-2.179,1.675-1.241,2.743L16,24L30.869,7.159 c-0.241-0.101-0.501-0.16-0.768-0.161L4.662,6.941z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "1~WE0Lz3GgLZUex~1j_nwb",
    x1: 17.184,
    x2: 27.74,
    y1: 23.368,
    y2: 36.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FC0449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC0449"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#1~WE0Lz3GgLZUex~1j_nwb)",
    d: "M38.056,14.996l-6.46-7.322c-0.202-0.229-0.452-0.401-0.727-0.516L16,24L3.457,38.215 c-0.951,1.078-0.192,2.769,1.24,2.782l10.785-0.007L38.056,14.996z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "1~WE0Lz3GgLZUex~1j_nwc",
    x1: 27.324,
    x2: 33.437,
    y1: 27.209,
    y2: 37.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FC0449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC0449"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#1~WE0Lz3GgLZUex~1j_nwc)",
    d: "M44.217,21.982l-6.161-6.985L15.482,41l14.796-0.01c0.506-0.046,0.98-0.273,1.319-0.658 l12.62-14.308C45.236,24.87,45.236,23.137,44.217,21.982z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24L30.869,7.159c-0.241-0.101-0.501-0.16-0.768-0.161l-0.423-0.001 L15.336,23.245L16,24z",
    opacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.669,23.624L16,24L30.869,7.159c-0.173-0.073-0.358-0.114-0.546-0.137 L15.669,23.624z",
    opacity: 0.07
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerAutomateSvg);
export default __webpack_public_path__ + "static/media/power-automate-svg.eb55268aecf1d6097c5bcec91aa91e15.svg";
export { ForwardRef as ReactComponent };